import { SkeletonWithoutBreadcrumbs } from '@townsquare/griffin-main-header/skeleton';
import Loadable from '@townsquare/loadable';
import type { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { LoadingState } from '@townsquare/starred-feed/skeleton';

import { starredRouteDefinition } from './route-definitions';

starredRouteDefinition.component = Loadable({
	loader: () => import(/* webpackChunkName: "starred-view" */ './components/StarredView'),
	loading: LoadingState,
});

starredRouteDefinition.header = Loadable({
	loader: () => import(/* webpackChunkName: "starred-header" */ './components/StarredHeader'),
	loading: SkeletonWithoutBreadcrumbs,
});

export const starredRoute: GlobalHomePageRoute = starredRouteDefinition;
